const xplanLabels = {
    id: "id",
    epId: "Experimental Plan",
    versionId: "Version",
    title: "Title",
    titleSMR: "Short Title (SMR)",
    showInSMR: "Show EP in SMR",
    status: "Status",
    statusComment: "Status Comments",
    related: "Related EPs",
    assignedToGroup: "Currently Assigned To",
    priority: "Priority",
    sampleDisposal: "Sample Disposal",
    scopeOfWorkRequired: "Will this EP require a Scope of Work (SOW)?",
    scopeOfWork: "Scope of Work (SOW)",
    scopeOfWorkVersion: "Scope of Work (SOW) Version",
    certificateOfDestructionRequired: "Will a Certificate of Destruction be required?",
    sampleRequestForm: "Sample Request Form / Abstract",
    sampleRequestFormVersion: "Sample Request Form / Abstract Version",
    materialTransferAgreementRequired: "Will this EP require a Material Transfer Agreement (MTA)?",
    materialTransferAgreement: "Material Transfer Agreement (MTA)",
    materialTransferAgreementVersion: "Material Transfer Agreement (MTA) Version",
    dataTransferAgreementRequired: "Will this EP require a Data Transfer Agreement (DTA)?",
    dataTransferAgreement: "Data Transfer Agreement (DTA)",
    dataTransferAgreementVersion: "Data Transfer Agreement (DTA) Version",
    approvalMessageRequired: "Has this EP been reviewed with the appropriate deputy director?",
    approvalMessageComment: "Comments (required if 'No')",
    approvalMessage: "Pre-Approval Correspondence",
    approvalMessageVersion: "Approval Message Version",
    confPub: "Conference or Publication",
    nihmsid: "NIH Manuscript Submission ID (NIHMSID)",
    publications: "Publications",
    createdBy: "Experimental Plan created by (biologist)",
    createdAt: "Experimental plan created at",
    updatedBy: "Experimental Plan updated by (biologist)",
    updatedAt: "Experimental Plan updated at",
    managedBy: "Experimental Plan managed by (biologist)",
    approvedBy: "Approval By",
    approvedDate: "Approval Date",
    initialNotes: "Initial Notes / Comments",
    protocol: "Protocol Number / Brand Name",
    otherName: "Other study number / name (include non-ITN study / experimental numbers here)",
    area: "Therapeutic Area",
    areaComment: "Area Comments",
    recipientInvestigator: "Recipient Investigator",
    labs: "DCE / Lab / Vendor to perform assay(s)",
    labsComment: "Lab Comments",
    labsAddress: "Lab Shipping Address",
    experimentType: "Experiment Type",
    genetic: "Future Genetic Testing",
    assayType: "Assay(s) to be performed",
    assayDetails: "Assay details",
    mechPurpose: "Mechanistic purpose(s) to be tested",
    itnFunded: "ITN Funded?",
    itnFundedMechanism: "Funding Mechanism",
    itnFundedComment: "Funding Comments (required if 'No')",
    itnFundedShipping: "Will ITN cover shipping costs?",
    itnFundedShippingComment: "Shipping Comments (e.g. courier account number)",
    siteAgreementStatus: "Site Agreement Status",
    chairApproval: "Study Protocol Chair and ITN CTP notified (if applicable)",
    chairApproval2: "NIAID, ITN Leadership, Study Protocol Chair, and/or ITN CTP notified (as appropriate)",
    chairApprovalComment: "Comments (required if 'No')",
    approvedSOP: "Approved Assay SOP",
    approvedSOPComment: "Comments (required if 'No' or 'Requested')",
    requestedCriteria: "Requested Samples Criteria (further details to be recorded inside Pull List)",
    smrStatusComment: "SMR Status Comments",
    informedConsent: "Informed Consent verification completed",
    blindingRequired: "Blinding required?",
    blindingComment: "Blinding Details",
    relabelingRequired: "Relabeling required?",
    relabelingDetails: "Relabeling Details",
    dispositionOfSample: "Planned Final Disposition of Samples",
    sortingComment: "Sorting Information",
    generalComment: "General Comments",
    approvalComment: "Approval Comments",
    legacyPullListLink: "Backup Pull List Link",
    legacyMigratedPullList: "Legacy Migrated Pull List",
};

export default xplanLabels;